import {
  EmergencyFundLocationEntity,
} from '@/modules/flagship/catalogs/emergency-fund-location/domain/entities/emergency-fund-location-entity';

export default class EmergencyFundLocationState {
  loaded = false;

  items: Array<EmergencyFundLocationEntity> = [];
}
